// extracted by mini-css-extract-plugin
export var about = "Home-module--about--7d0aa";
export var gatsbyImageWrapper = "Home-module--gatsby-image-wrapper--6b7ec";
export var hero = "Home-module--hero--62f19";
export var iconDown = "Home-module--icon-down--29638";
export var information = "Home-module--information--cde22";
export var logo = "Home-module--logo--8a6a7";